export var ApplicationName;
(function (ApplicationName) {
    ApplicationName["Admin"] = "admin";
    ApplicationName["Clinic"] = "clinic";
    ApplicationName["Connect"] = "connect";
    ApplicationName["Coder"] = "coder";
    ApplicationName["Designer"] = "designer";
    ApplicationName["Learning"] = "learning";
    ApplicationName["Logistics"] = "logistics";
    ApplicationName["Me"] = "me";
    ApplicationName["TMF"] = "tmf";
    ApplicationName["Reports"] = "reports";
    ApplicationName["PMS"] = "pms";
    ApplicationName["Viedoc"] = "viedoc";
})(ApplicationName || (ApplicationName = {}));
